import React, { useContext, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../../componentes/Plantilla/Plantilla';
import { DataContext } from '../../contexto/ContextoDatos';
import ContactSection from '../../componentes/Secciones/Contacto/SeccionContacto';
import LimpiezaTuberia from './LimpiezaTuberia';
import Breadcrumbs from '../../componentes/UI/Breadcrumbs';
import styles from './PaginaServicios.module.css';

export const ServiceDetail = () => {
  const { serviceSlug } = useParams();
  const { services } = useContext(DataContext);
  const service = services.find((s) => s.slug === serviceSlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceSlug]);

  if (!service) {
    return (
      <Layout>
        <div className="container" style={{ padding: '120px 24px', textAlign: 'center' }}>
          <h2>Servicio No Encontrado</h2>
          <p>El servicio solicitado no existe o ha sido modificado.</p>
          <Link to="/servicios" className="btn btn-primary" style={{ marginTop: '20px' }}>
            Ver Todos los Servicios
          </Link>
        </div>
      </Layout>
    );
  }

  if (service.slug === 'limpieza-tuberia-industrial') {
    return <LimpiezaTuberia />;
  }

  return (
    <Layout>
      {/* Banner Header */}
      <div 
        className={styles.bannerHeader}
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.75)), url(${service.image})` }}
      >
        <div className="container">
          <Breadcrumbs 
            paths={[
              { label: 'Inicio', to: '/' },
              { label: 'Servicios', to: '/servicios' },
              { label: service.name }
            ]}
          />
          <h1>{service.name}</h1>
          <p>{service.shortDescription}</p>
        </div>
      </div>

      {/* Main Content details */}
      <section className={styles.detailBodySection}>
        <div className="container">
          <div className="grid-2">
            {/* Info details */}
            <div>
              <h2 className={styles.detailSectionTitle}>Acerca de esta solución</h2>
              <p className={styles.detailDesc}>{service.description}</p>
              
              <h3 className={styles.specsTitle}>Alcances y Características</h3>
              <ul className={styles.detailSpecsList}>
                {service.specs.map((spec, i) => (
                  <li key={i} className={styles.detailSpecItem}>
                    <span className={styles.detailBullet}>✓</span>
                    <span>{spec}</span>
                  </li>
                ))}
              </ul>

              <div style={{ marginTop: '40px' }}>
                <Link to="/servicios" className="btn btn-secondary">
                  ← Volver a Servicios
                </Link>
              </div>
            </div>

            {/* CTA Sidebar card */}
            <div className={styles.sidebarCol}>
              <div className={styles.ctaCard}>
                <h3>Solicitar Asesoría de este Servicio</h3>
                <p>¿Requiere evaluar esta solución para su empresa o proyecto? Deje sus datos y un especialista técnico lo contactará de inmediato.</p>
                
                <a href="#contact" className="btn btn-primary" style={{ width: '100%' }}>
                  Cotizar Solución
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact form at the bottom */}
      <ContactSection />
    </Layout>
  );
};
export default ServiceDetail;
